/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const InvitationListResponse = zod
	.array(
		zod
			.object({
				email: zod.email().describe('Invitee email'),
				expires_at: zod.iso.datetime({ offset: true }).describe('Expiration timestamp'),
				id: zod.string().describe('Invitation ID'),
				invited_by: zod.email().nullable().describe('Inviter email'),
				role: zod.enum(['owner', 'member']),
				status: zod.enum(['pending', 'accepted', 'revoked', 'expired'])
			})
			.describe('Pending organization invitation')
	)
	.describe('List of pending invitations');

export type InvitationListResponse = zod.input<typeof InvitationListResponse>;
export type InvitationListResponseOutput = zod.output<typeof InvitationListResponse>;
